export const RESET_PRODUCT_ISFETCHING = 'RESET_PRODUCT_ISFETCHING';
export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const LIST_PRODUCTS_REQUEST = 'LIST_PRODUCTS_REQUEST';
export const PRODUCT_LIST_REQUESTING = 'PRODUCT_LIST_REQUESTING';
export const PRODUCT_OBJECT_REQUESTING = 'PRODUCT_OBJECT_REQUESTING';
export const LIST_PRODUCTS_SUCCESS = 'LIST_PRODUCTS_SUCCESS';
